import { render, staticRenderFns } from "./MallProfile.vue?vue&type=template&id=4b6a0849&scoped=true&"
import script from "./MallProfile.vue?vue&type=script&lang=js&"
export * from "./MallProfile.vue?vue&type=script&lang=js&"
import style0 from "./MallProfile.vue?vue&type=style&index=0&id=4b6a0849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6a0849",
  null
  
)

export default component.exports